export const filteredWords: string[] = [
    "eff",
    "fu",
    "gay",
    "lmafo",
    "lmao",
    "lmfao",
    "wtf",
]